import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Services from "../views/Services.vue";
import store from "../store";

import Subscription from "../components/privateViews/Subscriptions.vue";
import MyAccount from "../components/privateViews/MyAccount.vue";
import MyProfile from "../components/privateViews/MyProfile.vue";
import Subscribe from "../components/publicViews/FirstSubscribe.vue";

import Contact from "../components/privateViews/Contact.vue";

import GetStarted from "../components/publicViews/GetStarted.vue";
import Start from "../components/publicViews/Start.vue";
import Portfolio from "../components/publicViews/Portfolio.vue";
import SingleDemo from "../components/publicViews/SingleDemo.vue";

import SimpleProduct from "../views/products/SimpleProduct.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },

  {
    path: "/register",
    name: "register",
    component: Register
  },

  {
    path: "/services",
    name: "Services",
    component: Services
  },

  {
    path: "/getStarted",
    name: "getStarted",
    component: GetStarted
  },

  {
    path: "/start",
    name: "Start",
    component: Start
  },

  {
    path: "/portfolio",
    name: "Portfolio",
    component: Portfolio
  },

  {
    path: "/portfolio/:id",
    name: "SingleDemo",
    component: SingleDemo
  },

  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },

  {
    path: "/simple/project/:id",
    name: "SingleProject",
    component: SimpleProduct
  },
  
  {
    path: "/create/subscription/:id",
    name: "subscribe",
    component: Subscribe,
    props: true,
    meta: { requiresAuth: true, admin: true, }
    
  },
  {
    path: "/subscription",
    name: "subscription",
    component: Subscription,
    meta: { requiresAuth: true, admin: true, }
  },

  {
    path: "/account",
    name: "MyAccount",
    component: MyAccount,
    meta: { requiresAuth: true, admin: true, }
  },

  {
    path: "/profile",
    name: "myProfile",
    component: MyProfile,
    meta: { requiresAuth: true }
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.userAuth && localStorage.userEmail == '') {
      next({
          name: 'Login'
      })
    } 
    else if (to.matched.some(record => record.meta.admin) ) {
      // this route requires auth, check if logged in
      // if not, redirect to home page.
      if (localStorage.userEmail === 'jesse@vqventure.com') {
        next()
        
      } else {
        next({
          name: 'Home'
        })
       
      }
    } 

    else {
      next()
    }
  }
 
   else {
    next() // make sure to always call next()!
  }
})

export default router;
